;
(function (ng) {
  'use strict';

  angular.module('module', []);
})(window.angular);